var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-actions', {
    ref: "refreshCard",
    attrs: {
      "action-collapse": "",
      "title": "Daftar Karyawan"
    }
  }, [_c('b-row', {
    staticClass: "align-items-center"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_vm.allowCreate() ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.add($event);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Add')) + " ")], 1) : _vm._e()], 1), !_vm.isCabang ? _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.exportKaryawan($event);
      }
    }
  }, [_vm._v("Export")])], 1)]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "modal-tambah",
      "size": "xl",
      "ok-title": "Tutup",
      "ok-variant": "secondary",
      "ok-only": "",
      "centered": "",
      "title": "Form"
    },
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('validation-observer', {
    ref: "formKaryawan"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('h2', {
    staticClass: "alert-heading"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "UserIcon",
      "size": "19"
    }
  }), _vm._v("Data Personal")], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "NIK",
      "label-for": "v-nik"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nik",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-nik",
            "placeholder": "NIK",
            "type": "number"
          },
          model: {
            value: _vm.form.nik,
            callback: function ($$v) {
              _vm.$set(_vm.form, "nik", $$v);
            },
            expression: "form.nik"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Lengkap",
      "label-for": "v-nama-lengkap"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nama",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-nama-lengkap",
            "placeholder": "Nama Lengkap"
          },
          model: {
            value: _vm.form.nama_lengkap,
            callback: function ($$v) {
              _vm.$set(_vm.form, "nama_lengkap", $$v);
            },
            expression: "form.nama_lengkap"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Foto",
      "label-for": "v-file_foto"
    }
  }, [_c('input', {
    ref: "file_foto",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onSelectedImage
    }
  }), _vm.preview_image ? _c('div', {
    staticClass: "my-2"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.preview_image,
      "alt": ""
    }
  })]) : _vm._e()])], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Jenis Kelamin",
      "label-for": "v-jk"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "jk",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-select', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "options": _vm.optjk
          },
          model: {
            value: _vm.form.jk,
            callback: function ($$v) {
              _vm.$set(_vm.form, "jk", $$v);
            },
            expression: "form.jk"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Agama",
      "label-for": "v-agama"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "agama",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-select', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "options": _vm.optagama
          },
          model: {
            value: _vm.form.agama,
            callback: function ($$v) {
              _vm.$set(_vm.form, "agama", $$v);
            },
            expression: "form.agama"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tempat Lahir",
      "label-for": "v-tempat_lahir"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tempat_lahir",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-tempat_lahir",
            "placeholder": "Tempat Lahir"
          },
          model: {
            value: _vm.form.tempat_lahir,
            callback: function ($$v) {
              _vm.$set(_vm.form, "tempat_lahir", $$v);
            },
            expression: "form.tempat_lahir"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal Lahir",
      "label-for": "v-tanggal_lahir"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tanggal_lahir",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-input', {
          attrs: {
            "type": "date",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.tanggal_lahir,
            callback: function ($$v) {
              _vm.$set(_vm.form, "tanggal_lahir", $$v);
            },
            expression: "form.tanggal_lahir"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status Perkawinan",
      "label-for": "v-status_perkawinan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "status_perkawinan",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-select', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "options": _vm.optstatus_perkawinan
          },
          model: {
            value: _vm.form.status_perkawinan,
            callback: function ($$v) {
              _vm.$set(_vm.form, "status_perkawinan", $$v);
            },
            expression: "form.status_perkawinan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nomor HP",
      "label-for": "v-nomor-hp"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "no_hp",
      "rules": {
        min: 10,
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-nomor-hp",
            "placeholder": "Nomor HP",
            "type": "number"
          },
          model: {
            value: _vm.form.no_hp,
            callback: function ($$v) {
              _vm.$set(_vm.form, "no_hp", $$v);
            },
            expression: "form.no_hp"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "v-email"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "email",
      "rules": {
        required: true,
        email: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-email",
            "type": "email",
            "placeholder": "Email"
          },
          model: {
            value: _vm.form.email,
            callback: function ($$v) {
              _vm.$set(_vm.form, "email", $$v);
            },
            expression: "form.email"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('h2', {
    staticClass: "alert-heading"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "MapPinIcon",
      "size": "19"
    }
  }), _vm._v("Data Alamat")], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Provinsi",
      "label-for": "v-provinsi"
    }
  }, [_c('v-select', {
    attrs: {
      "reduce": function (option) {
        return option.value;
      },
      "label": "text",
      "options": _vm.optprovinsi
    },
    on: {
      "input": function ($event) {
        return _vm.getkabkota();
      }
    },
    model: {
      value: _vm.form.provinsi_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "provinsi_id", $$v);
      },
      expression: "form.provinsi_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kabupaten/Kota",
      "label-for": "v-kabko"
    }
  }, [_c('v-select', {
    attrs: {
      "reduce": function (option) {
        return option.value;
      },
      "label": "text",
      "options": _vm.optkabko
    },
    on: {
      "input": function ($event) {
        return _vm.getkecamatan();
      }
    },
    model: {
      value: _vm.form.kab_kota_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "kab_kota_id", $$v);
      },
      expression: "form.kab_kota_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kecamatan",
      "label-for": "v-kecamatan"
    }
  }, [_c('v-select', {
    attrs: {
      "reduce": function (option) {
        return option.value;
      },
      "label": "text",
      "options": _vm.optkec
    },
    on: {
      "input": function ($event) {
        return _vm.getkelurahan();
      }
    },
    model: {
      value: _vm.form.kecamatan_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "kecamatan_id", $$v);
      },
      expression: "form.kecamatan_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kelurahan/Desa",
      "label-for": "v-kel"
    }
  }, [_c('v-select', {
    attrs: {
      "reduce": function (option) {
        return option.value;
      },
      "label": "text",
      "options": _vm.optkel
    },
    model: {
      value: _vm.form.desa_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "desa_id", $$v);
      },
      expression: "form.desa_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Alamat",
      "label-for": "v-alamat"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nip",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-alamat",
            "placeholder": "Alamat Lengkap"
          },
          model: {
            value: _vm.form.alamat,
            callback: function ($$v) {
              _vm.$set(_vm.form, "alamat", $$v);
            },
            expression: "form.alamat"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('h2', {
    staticClass: "alert-heading"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "BookOpenIcon",
      "size": "19"
    }
  }), _vm._v("Data Pendidikan ")], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pendidikan Terakhir",
      "label-for": "v-pendidikan_terakhir"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "pendidikan_terakhir",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref11) {
        var errors = _ref11.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-pendidikan_terakhir",
            "placeholder": "Pendidikan Terakhir"
          },
          model: {
            value: _vm.form.pendidikan_terakhir,
            callback: function ($$v) {
              _vm.$set(_vm.form, "pendidikan_terakhir", $$v);
            },
            expression: "form.pendidikan_terakhir"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kampus / Sekolah",
      "label-for": "v-kampus_sekolah"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "kampus_sekolah",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref12) {
        var errors = _ref12.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-kampus_sekolah",
            "placeholder": "Kampus / Sekolah"
          },
          model: {
            value: _vm.form.kampus_sekolah,
            callback: function ($$v) {
              _vm.$set(_vm.form, "kampus_sekolah", $$v);
            },
            expression: "form.kampus_sekolah"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kualifikasi Pendidikan",
      "label-for": "v-kualifikasi_pendidikan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "kualifikasi_pendidikan",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref13) {
        var errors = _ref13.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-kualifikasi_pendidikan",
            "placeholder": "Kualifikasi Pendidikan"
          },
          model: {
            value: _vm.form.kualifikasi_pendidikan,
            callback: function ($$v) {
              _vm.$set(_vm.form, "kualifikasi_pendidikan", $$v);
            },
            expression: "form.kualifikasi_pendidikan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('h2', {
    staticClass: "alert-heading"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "UserCheckIcon",
      "size": "19"
    }
  }), _vm._v("Data Kepegawaian")], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "NIP",
      "label-for": "v-nip"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nip",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref14) {
        var errors = _ref14.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-nip",
            "placeholder": "NIP",
            "type": "number"
          },
          model: {
            value: _vm.form.nip,
            callback: function ($$v) {
              _vm.$set(_vm.form, "nip", $$v);
            },
            expression: "form.nip"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Jabatan",
      "label-for": "v-jabatan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "jabatan",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref15) {
        var errors = _ref15.errors;
        return [_c('b-form-select', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "options": _vm.optjabatan_id,
            "label": "Jabatan"
          },
          model: {
            value: _vm.form.jabatan_id,
            callback: function ($$v) {
              _vm.$set(_vm.form, "jabatan_id", $$v);
            },
            expression: "form.jabatan_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status Karyawan",
      "label-for": "v-status_karyawan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "status_karyawan",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref16) {
        var errors = _ref16.errors;
        return [_c('b-form-select', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "options": _vm.optstatus_karyawan
          },
          model: {
            value: _vm.form.status_karyawan,
            callback: function ($$v) {
              _vm.$set(_vm.form, "status_karyawan", $$v);
            },
            expression: "form.status_karyawan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status SP",
      "label-for": "v-status_sp"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "status_sp",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref17) {
        var errors = _ref17.errors;
        return [_c('b-form-select', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "options": _vm.optstatus_sp
          },
          model: {
            value: _vm.form.status_sp,
            callback: function ($$v) {
              _vm.$set(_vm.form, "status_sp", $$v);
            },
            expression: "form.status_sp"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Masa Kerja",
      "label-for": "v-masa_kerja"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "masa_kerja",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref18) {
        var errors = _ref18.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-masa_kerja",
            "placeholder": "Masa Kerja"
          },
          model: {
            value: _vm.form.masa_kerja,
            callback: function ($$v) {
              _vm.$set(_vm.form, "masa_kerja", $$v);
            },
            expression: "form.masa_kerja"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Grade Karyawan",
      "label-for": "v-grade_karyawan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "grade_karyawan",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref19) {
        var errors = _ref19.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-grade_karyawan",
            "placeholder": "Grade Karyawan"
          },
          model: {
            value: _vm.form.grade_karyawan,
            callback: function ($$v) {
              _vm.$set(_vm.form, "grade_karyawan", $$v);
            },
            expression: "form.grade_karyawan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('h2', {
    staticClass: "alert-heading"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "CreditCardIcon",
      "size": "19"
    }
  }), _vm._v("Data Rekening ")], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Bank",
      "label-for": "v-nama_bank"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nama_bank",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref20) {
        var errors = _ref20.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-nama_bank",
            "placeholder": "Ex: BSi / BCA",
            "type": "text"
          },
          model: {
            value: _vm.form.nama_bank,
            callback: function ($$v) {
              _vm.$set(_vm.form, "nama_bank", $$v);
            },
            expression: "form.nama_bank"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "No. Rekening",
      "label-for": "v-no_rekening"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "no_rekening",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref21) {
        var errors = _ref21.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-no_rekening",
            "placeholder": "Ex: 81742894719824 (tanpa spasi)"
          },
          model: {
            value: _vm.form.no_rekening,
            callback: function ($$v) {
              _vm.$set(_vm.form, "no_rekening", $$v);
            },
            expression: "form.no_rekening"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Deskripsi",
      "label-for": "v-deskripsi"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "deskripsi",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref22) {
        var errors = _ref22.errors;
        return [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "id": "v-deskripsi",
            "placeholder": "Ex : a.n Nomor rekening tersebut"
          },
          model: {
            value: _vm.form.deskripsi,
            callback: function ($$v) {
              _vm.$set(_vm.form, "deskripsi", $$v);
            },
            expression: "form.deskripsi"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "type": "submit",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.label || "Submit") + " ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-rekening",
      "size": "xl",
      "ok-title": "Tutup",
      "ok-variant": "secondary",
      "ok-only": "",
      "centered": "",
      "title": "Daftar Rekening"
    },
    model: {
      value: _vm.showrekening,
      callback: function ($$v) {
        _vm.showrekening = $$v;
      },
      expression: "showrekening"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('h2', {
    staticClass: "alert-heading"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "CreditCardIcon",
      "size": "19"
    }
  }), _vm._v("Add Rekening ")], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-form', [_c('b-form-group', [_c('label', {
    attrs: {
      "for": "nama_bank"
    }
  }, [_vm._v("Nama Bank")]), _c('b-form-input', {
    attrs: {
      "id": "nama_bank",
      "type": "text",
      "placeholder": "Nama Bank"
    },
    model: {
      value: _vm.formrekening.nama,
      callback: function ($$v) {
        _vm.$set(_vm.formrekening, "nama", $$v);
      },
      expression: "formrekening.nama"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": "no_rekening"
    }
  }, [_vm._v("No. Rekening")]), _c('b-form-input', {
    attrs: {
      "id": "no_rekening",
      "placeholder": "No. Rekening"
    },
    model: {
      value: _vm.formrekening.no_rekening,
      callback: function ($$v) {
        _vm.$set(_vm.formrekening, "no_rekening", $$v);
      },
      expression: "formrekening.no_rekening"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": "reward"
    }
  }, [_vm._v("Deskripsi")]), _c('b-form-input', {
    attrs: {
      "id": "deskripsi",
      "placeholder": "Deskripsi"
    },
    model: {
      value: _vm.formrekening.deskripsi,
      callback: function ($$v) {
        _vm.$set(_vm.formrekening, "deskripsi", $$v);
      },
      expression: "formrekening.deskripsi"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": "reward"
    }
  }, [_vm._v("Rekening Utama ? ")]), _c('b-form-checkbox', {
    staticClass: "ml-2",
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formrekening.rekening_utama,
      callback: function ($$v) {
        _vm.$set(_vm.formrekening, "rekening_utama", $$v);
      },
      expression: "formrekening.rekening_utama"
    }
  })], 1)], 1), _c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.submitrekening
    }
  }, [_vm._v(" Add ")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8",
      "sm": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "responsive": "",
      "items": _vm.itemsrekening,
      "fields": [{
        key: 'no',
        label: 'No'
      }, {
        key: 'nama',
        label: 'Nama Bank'
      }, {
        key: 'no_rekening',
        label: 'No. Rekening'
      }, {
        key: 'type',
        label: 'Tipe'
      }, {
        key: 'deskripsi',
        label: 'Deskripsi'
      }, {
        key: 'rekening_utama',
        label: 'Rekening Utama'
      }, {
        key: 'actions',
        label: 'Aksi'
      }]
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function (_ref23) {
        var index = _ref23.index;
        return [_c('strong', {
          staticClass: "text-center"
        }, [_vm._v(" " + _vm._s(index + 1) + " ")])];
      }
    }, {
      key: "cell(type)",
      fn: function (row) {
        return [_c('strong', {
          staticClass: "text-center"
        }, [row.value == 'income' ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Income")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Withdraw")])], 1)];
      }
    }, {
      key: "cell(rekening_utama)",
      fn: function (row) {
        return [_c('strong', {
          staticClass: "text-center"
        }, [row.value == true ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Ya")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Tidak")])], 1)];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "title": "'Ubah'",
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function ($event) {
              return _vm.editrekening(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        })], 1), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "title": "'Hapus'",
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function ($event) {
              return _vm.removerekening(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2",
      "sm": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": _vm.$t('Per page'),
      "label-size": "sm",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function ($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4",
      "sm": "8"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": _vm.$t('Sort'),
      "label-size": "sm",
      "label-for": "sortBySelect"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-select', {
    staticClass: "w-75",
    attrs: {
      "id": "sortBySelect",
      "options": _vm.sortOptions
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("-- none --")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.sortBy,
      callback: function ($$v) {
        _vm.sortBy = $$v;
      },
      expression: "sortBy"
    }
  }), _c('b-form-select', {
    staticClass: "w-25",
    attrs: {
      "size": "sm",
      "disabled": !_vm.sortBy
    },
    model: {
      value: _vm.sortDesc,
      callback: function ($$v) {
        _vm.sortDesc = $$v;
      },
      expression: "sortDesc"
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Asc")]), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Desc")])])], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": _vm.$t('Filter'),
      "label-size": "sm",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search"
    },
    model: {
      value: _vm.filter,
      callback: function ($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function ($event) {
        _vm.filter = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Clear')))])], 1)], 1)], 1)], 1), !_vm.isCabang ? _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Pilih Affiliator",
      "label-for": "is_member"
    }
  }, [_c('b-input-group', [_c('b-form-select', {
    attrs: {
      "size": "sm",
      "id": "is_member",
      "options": _vm.optis_member
    },
    on: {
      "input": function ($event) {
        return _vm.getData();
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("-- Semua --")])];
      },
      proxy: true
    }], null, false, 437768337),
    model: {
      value: _vm.is_member,
      callback: function ($$v) {
        _vm.is_member = $$v;
      },
      expression: "is_member"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "items": _vm.items,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "filter": _vm.filter,
      "filter-included-fields": _vm.filterOn
    },
    on: {
      "update:sortBy": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event;
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "cell(id)",
      fn: function (_ref24) {
        var item = _ref24.item;
        return [_vm._v(" " + _vm._s(item.index + 1) + " ")];
      }
    }, {
      key: "cell(foto)",
      fn: function (_ref25) {
        var item = _ref25.item;
        return [item.url_foto ? _c('img', {
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "src": item.url_foto,
            "alt": "Foto"
          }
        }) : _c('feather-icon', {
          attrs: {
            "icon": "UserIcon",
            "size": "32"
          }
        })];
      }
    }, {
      key: "cell(jk)",
      fn: function (data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.jk[1][data.value]
          }
        }, [_vm._v(" " + _vm._s(_vm.jk[0][data.value]) + " ")])];
      }
    }, {
      key: "cell(jabatan_id)",
      fn: function (data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(" " + _vm._s(_vm.getJabatanName(data.item)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_vm.allowUpdate() ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "title": "Rekening",
            "size": "sm",
            "variant": "info"
          },
          on: {
            "click": function ($event) {
              return _vm.rekening(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "CreditCardIcon"
          }
        })], 1) : _vm._e(), _vm.allowUpdate() ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "title": _vm.$t('Edit'),
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function ($event) {
              return _vm.edit(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        })], 1) : _vm._e(), _vm.allowDelete() ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "title": _vm.$t('Delete'),
            "ssize": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function ($event) {
              return _vm.remove(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1) : _vm._e()];
      }
    }, {
      key: "row-details",
      fn: function (row) {
        return [_c('b-card', [_c('ul', _vm._l(row.item, function (value, key) {
          return _c('li', {
            key: key
          }, [_vm._v(" " + _vm._s(key) + ": " + _vm._s(value) + " ")]);
        }), 0)])];
      }
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }